import React from 'react';
import PropTypes from 'prop-types';
/* Styles */
import './widget-type-item.scss';

class WidgetTypeItem extends React.PureComponent {
  handleDragStart = (e) => {
    // e.persist();
    this.draggable.style.opacity = '0.5';
    e.dataTransfer.setData('text/plain', '');
    this.props.onDragStart(this.props.widget);
  };

  handleDragEnd = () => {
    this.draggable.style.opacity = '1';
  };

  render() {
    return (
      <div
        ref={(draggable) => {
          this.draggable = draggable;
        }}
        className="glu-card glu-flex-row glu-flex-align-center cursor-grab"
        unselectable="on"
        draggable
        onDragEnd={this.handleDragEnd}
        onDragStart={this.handleDragStart}
        onClick={this.props.onClick(this.props.widget)}
      >
        <div className="glu-flex-shrink">
          <div className="g-icon g-icon-drag" />
        </div>
        <div className="glu-flex-grow">
          <div className="glu-h3">{this.props.widget.title}</div>
        </div>
        <div className="glu-flex-row">
          {this.props.widget.tags
            .filter((el) => {
              return ['new', 'generic'].includes(el.title.toLowerCase());
            })
            .map((tag) => (
              <div className="glu-flex-shrink" key={tag.id}>
                <div
                  className={`glu-pill glu-pill--${tag.title.toLowerCase()}`}
                  style={{backgroundColor: tag.bgColor ? tag.bgColor : ''}}
                >
                  {tag.title}
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

WidgetTypeItem.propTypes = {
  onDragStart: PropTypes.func.isRequired,
  widget: PropTypes.objectOf(PropTypes.any).isRequired,
  onClick: PropTypes.func,
};

WidgetTypeItem.defaultProps = {
  onClick: undefined,
};

export default WidgetTypeItem;
